import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface OcrSpaceResponse {
  ParsedResults?: Array<{
    ParsedText?: string;
  }>;
  IsErroredOnProcessing?: boolean;
  ErrorMessage?: string | string[];
  OCRExitCode?: number;
}

@Injectable({ providedIn: 'root' })
export class OcrSpaceService {

  // url for free use: https://api.ocr.space/parse/image
  // https://apipro2.ocr.space/parse/image
  // https://apipro1.ocr.space/parse/image
  private readonly endpoint = 'https://apipro1.ocr.space/parse/image';

  // ⚠️ SOLO PARA POC
  // private readonly apiKey = 'helloworld'; // o tu key free real
  // private readonly apiKey = 'P8987Y4ERARRX'; // esanweb paid key
  // private readonly apikey = 'K89826181488957'; // free key
  private readonly apiKey = 'P8989XFK55E3X';// hoomvip paid key


  constructor(private http: HttpClient) {}

  ocrMrz(file: File): Observable<OcrSpaceResponse> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('apikey', this.apiKey);
    formData.append('language', 'eng');
    formData.append('isOverlayRequired', 'false');
    formData.append('isTable', 'false');
    formData.append('scale', 'true');
    formData.append('OCREngine', '2');

    return this.http.post<OcrSpaceResponse>(this.endpoint, formData);
  }
}
